<template>
  <section>
    <h2>Insurers</h2>
    <div class="insurer-list">
      <div
        v-for="(insurer, i) in insurerList"
        :key="i"
        class="insurer-item pointer"
        @click="insurerClick(insurer)">
        <div class="logo">
          <img :src="getOptionData('companyLargeIcon', insurer.id).logo">
        </div>
        <p class="name">{{insurer.name}}</p>
      </div>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
export default {
  name: 'Insurer',
  mixins: [MixinOptions],
  data () {
    return {

    }
  },
  computed:{
    insurerList(){
      let arr = this.insurerAllOptions || []
      arr.forEach(item => {
        if(item.id == 17){
          item.name = 'Tokio Marine'
        }
      })
      return arr
    }
  },
  methods: {
    insurerClick(item){
      const {id} = item
      this.$router.push({
        name: 'insurerAccountsPlan',
        query: {
          company_id: id
        }
      })
    }
  },
}
</script>
<style lang='scss' scoped>
section{
  h2{
    font-weight: 600;
    font-size: 24px;
    height: 36px;
    line-height: 36px;
    color: #24292E;
  }
  .insurer-list{
    padding: 30px 0;
    display: flex;
    flex-wrap: wrap;
    .insurer-item{
      display: flex;
      flex-direction: column;
      width: 184px;
      height: 140px;
      background: #FFFFFF;
      border: 1px solid #D1D5DA;
      border-radius: 5px;
      margin: 10px;
      .logo{
        margin: 15px 17px 10px 17px;
        width: 150px;
        height: 80px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .name{
        font-weight: 600;
        font-size: 14px;
        text-align: center;
        color: #24292E;
      }
    }
  }
}
</style>
